var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"overflow":"auto"}},[(_vm.option)?_c('EChartWrapper',{staticStyle:{"height":"450px","width":"1100px"},attrs:{"index":_vm.index,"option":_vm.option}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }